import React from 'react';

import styles from './XTabPanel.module.scss';
import {} from "../../Utilities/Utilities";
import { XComponent } from '../commons/XComponent';
import { IComponentState } from '../commons/IComponentState';
import { IComponentProps } from '../commons/IComponentProps';
import { ETheme } from '../../types/enums/ETheme';

export interface ITabProps extends IComponentProps {
    children? : React.ReactNode;
    header? : string | undefined;
    theme?: ETheme;
}

export interface ITabState extends IComponentState {
    theme: ETheme;
}

export class XTab extends XComponent<HTMLDivElement, ITabProps, ITabState> {
    static defaultProps = {
        ...XComponent.defaultProps,
        theme: ETheme.Blue,
    }
    reference: React.RefObject<HTMLDivElement>;
    isDragging: boolean = false;
    offsetX: number = 0;
    //offsetY: number = 0;

    public constructor(props: ITabProps) {
        super(props);
        this.state = {
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme,
        };
        this.DoMouseDown = this.DoMouseDown.bind(this);
        this.DoMouseMove = this.DoMouseMove.bind(this);
        this.DoMouseUp = this.DoMouseUp.bind(this);
        this.reference = React.createRef();
    }
    private DoMouseDown(event: MouseEvent): void {
        // if(event.offsetY > 28)
        //     return;
        if(!this.reference.current)
            return;
        if(event.buttons !== 1) {
            return;
        }

        const target: HTMLDivElement = this.reference.current;

        this.isDragging = true;
        
        this.offsetX = event.clientX /*- target.offsetLeft*/- target.clientLeft /*- this.offsetX*/;
        //target.style.left = `${event.clientX - this.offsetX}px`;
        //this.offsetY = event.clientY - target.offsetTop;
        target.style.zIndex = '1';
        document.addEventListener('mousemove', this.DoMouseMove);
        document.addEventListener('mouseup', this.DoMouseUp);        
    }
    private DoMouseMove(event: MouseEvent): void {        
        if (this.isDragging) {
            if(!this.reference.current)
                return;
            if(event.buttons !== 1) {
                this.DoMouseUp(event);
                return;
            }
            if(document.body.style.cursor !== 'move')
                document.body.style.cursor = 'move';
            const target: HTMLDivElement = this.reference.current;
            if(!target.parentElement)
                return;
            const left = target.parentElement?.offsetLeft;
            const delta = target.offsetLeft - target.parentElement?.offsetLeft;
            let pos = Math.min(
                    Math.max(event.clientX, left),
                    left + target.parentElement?.offsetWidth);
            console.log(`parent.offcetLeft ${left}`);
            console.log(`parent.clientLeft ${target.parentElement?.clientLeft}`);
            console.log(`target.offcetLeft ${target.offsetLeft}`);
            console.log(`target.clientLeft ${target.clientLeft}`);
            // if(delta < 0)
            //     pos = pos - delta;
            // if(delta < 0)
            //      pos = 0;
                    //console.log(`pos ${pos}, p+ ${pos - this.offsetX}, tl ${target.parentElement?.offsetLeft}, tlo ${target.offsetLeft}, cl ${event.clientX}, of ${this.offsetX}, ${target.clientWidth}, dd- ${delta}`);
            target.style.left = `${pos - this.offsetX}px`;            
            //target.style.top = `${event.clientY - this.offsetY}px`;
        }
    }
    private DoMouseUp(event: MouseEvent): void {
        event.stopPropagation();
        if(!this.isDragging)
            return;
        this.isDragging = false;
        document.body.style.cursor = 'default';
        document.removeEventListener('mousemove', this.DoMouseMove);
        document.removeEventListener('mouseup', this.DoMouseUp);

        if(!this.reference.current)
            return;

        const target: HTMLDivElement = this.reference.current;
        target.style.zIndex = 'unset';
        target.style.left = 'unset';
        const tabs = target.parentElement?.children;
        if(tabs)
        {
            let isMoved: boolean = false;
            for(let i = 0; i < tabs.length; i++)
            {
                if(tabs[i].classList.contains(styles.XTab)) {
                    const div = tabs[i] as HTMLDivElement;
                    if(div === this.reference.current)
                        continue;
                    const x = event.clientX - div.offsetLeft;//left;
                    if(x < 0){
                        isMoved = true;
                        break;
                    }
                    const width = div.clientWidth;
                    if(x > width)
                        continue;                    
                    const half = Math.round(width / 2);
                    if(x < half)
                    {
                        target.parentElement?.insertBefore(target, div);
                        isMoved = true;
                        break;
                    }
                    else
                    {
                        target.parentElement?.insertBefore(target, div.nextElementSibling);
                        isMoved = true;
                        break;
                    }
                }
            }
            if(!isMoved)
                target.parentElement?.insertBefore(target, tabs[tabs.length -1].nextElementSibling);

        }
    }

    componentDidMount(): void{
        if(this.reference.current)
            this.reference.current.onmousedown = this.DoMouseDown;
    }
    componentWillUnmount(): void{}
    componentDidUpdate(prevProps: any, prevState: any) {     
    }
    render(): React.ReactNode {
        return (
            <div ref={this.reference} className={styles.XTab} data-theme={this.state.theme}>
                {this.props.header}
            </div>
        );
    }
}



export interface ITabBarProps extends IComponentProps {
    children?: (React.ReactElement<XTab> | Iterable<React.ReactElement<XTab>>) & React.ReactNode;
}

export interface ITabBarState extends IComponentState {
}

export class XTabBar extends XComponent<HTMLDivElement, ITabBarProps, ITabBarState> {
    public constructor(props: any) {
        super(props);
    }
    render(): React.ReactNode {
        return (
            <div className={styles.XTabBar}>         
                {this.props.children}
            </div>
        );
    }
}



export interface ITabPanelProps extends IComponentProps {
    children?: (React.ReactElement<XTab> | Iterable<React.ReactElement<XTab>>) & React.ReactNode;
}

export interface ITabPanelState extends IComponentState {
}

export class XTabPanel extends XComponent<HTMLDivElement, ITabPanelProps, ITabPanelState> {
    public constructor(props: any) {
        super(props);
    }
    render(): React.ReactNode {
        return (
            <div className={styles.XTabPanel}>         
                <XTabBar>
                    {this.props.children}
                </XTabBar>                
            </div>
        );
    }
}